import { useEffect } from 'react';
// import { useSelector } from 'react-redux';
import i18n, { addTranslations } from '../utils/i18n';

function useLangInit(module) {
  // const adminData = useSelector((state) => state.admin);
  // const { lang_src_url, tenant_domain, is_custom_language } = adminData;
  const lang_src_url = 'https://d2cl07xv2ii8xi.cloudfront.net/student-dashboard-saasdev';
  const tenant_domain = 'https://d2cl07xv2ii8xi.cloudfront.net/student-dashboard-saasdev';
  const is_custom_language = false;
  // const is_custom_language = adminData?.is_custom_language;

  useEffect(() => {
    const langhandler = (lng) => {
      // console.log(lng);
      if (i18n.language && lang_src_url && tenant_domain) {
        if (module) {
          addTranslations({ langSrcUrl: lang_src_url, module, folder: tenant_domain, is_custom_language });
        } else {
          addTranslations({ langSrcUrl: lang_src_url, folder: tenant_domain, is_custom_language });
        }
      }
    };
    langhandler();
    i18n.on('languageChanged', langhandler);
    return () => {
      i18n.off('languageChanged', langhandler);
    };
  }, [module, lang_src_url, tenant_domain]);
}

export default useLangInit;
